const clientIdInput = document.getElementById('ga_client_id');
const sessionIdInput = document.getElementById('ga_session_id');
const sessionNumberInput = document.getElementById('ga_session_number');

function fetchClientId() {
  if (typeof window.ga === 'undefined') {
    setTimeout(fetchClientId, 2000);
    return;
  }

  window.ga(() => {
    const t = window.ga.getAll();
    let clientId;

    if (t && t.length) {
      clientId = t[0].get('clientId');
      clientIdInput.value = clientId;
    } else {
      setTimeout(fetchClientId, 2000);
    }
  });
}

function fetchSessionId() {
  if (typeof gtag === 'undefined' || !window.ga4StreamId) {
    setTimeout(fetchSessionId, 1000);
    return;
  }

  const streamId = window.ga4StreamId;

  window.gtag('get', streamId, 'session_id', (sessionId) => {
    sessionIdInput.value = sessionId;
  });

  window.gtag('get', streamId, 'session_number', (sessionNumber) => {
    sessionNumberInput.value = sessionNumber;
  });
}

if (clientIdInput) {
  fetchClientId();
}

if (sessionIdInput && sessionNumberInput) {
  fetchSessionId();
}
